import Badge from '@passkeys/ui/badge';
import Icon from '@passkeys/ui/icon';

import exodus from '@/ui/exodus';
import useBackupStatus from '@/ui/hooks/use-backup-status';
import Item from './item.js';

function BackupBadge() {
  const { loading, backedUp } = useBackupStatus();

  if (loading) {
    return null;
  }

  return (
    <Badge variant={backedUp ? 'green' : 'red'} className="uppercase">
      {backedUp ? 'Complete' : 'Missing'}
    </Badge>
  );
}

function Backup() {
  const handleBackupClick = async () => {
    exodus.pairing.start();
  };

  return (
    <Item
      icon="hard-drive"
      label="Backup"
      description="Create a copy of your Passkey on another device. Some platforms do this automatically for you."
      dataTestId="backup-settings-item"
      onClick={handleBackupClick}
    >
      <div className="flex items-center gap-x-2">
        <BackupBadge />
        <Icon
          className="text-black/40 theme-dark:text-neutral-400"
          name="caret-right"
          size={16}
        />
      </div>
    </Item>
  );
}

export default Backup;
